export const getInitialChartState = () => {
    const initialChartState = {
        rawData: undefined,
    };
    return initialChartState;
};
